import "./App.css";
import io from "socket.io-client";
import { useEffect, useState } from "react";

const socket = io.connect("https://websockettest-270ff.web.app/");

function App() {
  const [room, setRoom] = useState("");
  const [message, setMessage] = useState("");
  const [messageRec, setMessageRec] = useState("");

  const joinRoom = () => {
    if (room !== "") {
    console.log('room :', room);
      socket.emit("join_room", room);
    }
  };

  const sendMessage = () => {
    socket.emit("send_message", { message, room });
  };

  useEffect(() => {
    socket.on("receive_message", (data) => {
    console.log('USE EFFECT data :', data);
      setMessageRec(data.message);
    });
  }, [socket]);

  return (
    <div className="App">
      <input
        placeholder="Room Number..."
        onChange={(event) => {
          setRoom(event.target.value);
        }}
      />
      <button onClick={joinRoom}>Join Room</button>
      <input
        onChange={(event) => {
          setMessage(event.target.value);
        }}
        placeholder="Message..."
      />
      <button onClick={() => sendMessage()}> SEND MESSAGE</button>
      <h1>Message: {messageRec}</h1>
    </div>
  );
}

export default App;
